export enum EnumDemoMobilePhoneColor
{
    White = "White",
    Black = "Black",
    AlpineGreen = "AlpineGreen",
    MidnightGray = "MidnightGray"
}